export default "__VITE_ASSET__BWJJMf4V__"